import { EnAuthOptionsOperator } from '@shared/enums/auth-options-operator.enum';
import { SUPER_ADMIN_PERMISSION } from '@shared/constants/auth';

/**
 * Whether `granted` satisfies `required` under AND or OR.
 * Shared by AuthService and PermissionService so the two gates cannot drift.
 */
export function matchAuthOptions(
  required: readonly string[],
  granted: readonly string[],
  operator: EnAuthOptionsOperator,
): boolean {
  if (operator === EnAuthOptionsOperator.OR) {
    return required.some(permission => granted.includes(permission));
  }
  return required.length > 0 && required.every(permission => granted.includes(permission));
}

/**
 * SUPER_ADMIN bypasses every non-exact check. Also shared by AuthService and
 * PermissionService: each used to carry its own copy of this same
 * `includes(SUPER_ADMIN_PERMISSION)` check, one live surface that could
 * silently diverge from the other on a future change to wildcard semantics.
 */
export function hasSuperAdminWildcard(granted: readonly string[]): boolean {
  return granted.includes(SUPER_ADMIN_PERMISSION);
}
